<template>
  <drag-dialog
    :visible.sync="visible"
    custom-class="append-dialog"
    :title="'导入设备材料检测信息'"
    width="700px"
    height="450px"
    append-to-body
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset()"
  >
    <section class="import_box">
      <div class="content">
        <el-upload
          class="upload-demo"
          drag
          ref="upload"
          :on-change="fileChange"
          :auto-upload="false"
          :action="''"
          accept=".xlsx,.xls"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">导入文件不能超过20M，请使用指定的“下载模版”进行导入！</div>
        </el-upload>
      </div>
    </section>
    <template slot="footer">
      <a class="model" :href="VUE_APP_BASE_API + downLoadUrl">
        <i class="el-icon-download"></i>
        <span>下载模板</span>
      </a>
      <el-button :loading="importLoading" type="primary" @click="importFile">导 入</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import { getToken } from '@/utils/auth';
import { readTotEntrustmentFromExcel } from '@/api/entrust';

export default {
  name: 'ImportDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 模板地址
    downLoadUrl: {
      type: String,
      default: '',
      required: true
    },
    // 其他参数
    otherData: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data() {
    return {
      importLoading: false,
      fileList: [],
      VUE_APP_BASE_API: process.env.VUE_APP_BASE_API
    };
  },
  watch: {
    visible(value) {
      if (!value) {
        this.$refs.upload.clearFiles();
      }
    }
  },
  methods: {
    async importFile() {
      if (this.fileList.length > 0) {
        this.importLoading = true;

        let formData = new FormData();
        let file = this.fileList[0].raw;
        formData.append('excel', file);
        formData.append('token', getToken());
        for (var key in this.otherData) {
          formData.append(key, this.otherData[key]);
        }

        try {
          const { data } = await readTotEntrustmentFromExcel(formData);

          this.$emit('setEditForm', data);
          this.$message.success('导入成功！');
          this.$emit('update:visible', false);
        } finally {
          this.importLoading = false;
        }
      } else {
        this.$message({
          message: '请先选择文件',
          type: 'warning'
        });
      }
    },
    fileChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      this.fileList = fileList;
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
.import_box {
  display: flex;
  justify-content: center;
  padding-top: 16px;
  width: 100%;
  height: 100%;

  ::v-deep .upload-demo {
    width: 500px !important;
  }

  ::v-deep .el-upload-dragger {
    width: 500px !important;
  }

  ::v-deep .el-upload-dragger {
    margin: 0 auto;
  }
}

.model {
  margin-right: 30px;
  font-size: 14px;
  color: #64bfc1;
  cursor: pointer;
}
</style>
